import React, {useState, useEffect, useContext} from "react";
import {Outlet} from "react-router-dom";
import UserContext from "../../utils/context/user/userContext";
import Sidebar from "../../components/Sidebar/Sidebar";
import Footer from "../../components/Footer";
import Preloader from "../../components/Preloader";
import Signin from "../public/Signin/Signin";
import { solutionGroupsRequest } from "../../utils/request/api";
import { sleep } from "../../utils/actions/actions";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const RouteWithSidebar = ({hideBar, setHideBar}) => {

  const userContext = useContext(UserContext);
  const [loaded, setLoaded] = useState(false);
  const [solutionsGroupsList, setSolutionsGroupsList] = useState([]);
  const [sideBarLoading, setSideBarLoading] = useState(false);
  
  useEffect(() => {
    const fetchData = async () => {
    setSideBarLoading(true);

    await sleep(2000);

    try {
      const r = await solutionGroupsRequest();
      setSolutionsGroupsList([...(r.data?.content || [])]);
    } catch (error) {
      console.error("Errore nella richiesta:", error);
    } finally {
      setSideBarLoading(false);
      setLoaded(true);
    }
  };

  fetchData();
  }, [userContext.user]);

  if(userContext.isAuth){
    return (
        <>
          <Preloader show={!loaded} />
          
          <Sidebar loading={sideBarLoading} user={userContext.user} groupList={solutionsGroupsList} logoutHandler={userContext.handleUserLogout} profileHandler={userContext.handleProfileChange} hideBar={hideBar} setHideBar={setHideBar}/>
          {
            hideBar !== "HIDDEN" &&
            <button disabled={hideBar === "ALWAYS OPEN"} className={`hide-sidebar-button ${ hideBar === "ALWAYS OPEN" ? "external-slide-left" : hideBar === null ? "" :  hideBar ? "external-slide-to-left" : "external-slide-to-right"}`}  onClick={() => setHideBar(!hideBar)}>
              <FontAwesomeIcon icon={hideBar && hideBar !== "ALWAYS OPEN" ? faChevronRight : faChevronLeft} />
            </button>
          }
          <main className={`content ${ hideBar === "ALWAYS OPEN" ? "external-slide-left" : hideBar === null ? "" :  hideBar ? "internal-content-to-left" : "internal-content-to-right"}`}>
            <Outlet/>
            <Footer />
          </main>
        </>
    );
  }
  else { 
    return (
      <Signin/>
    );
  }
};

export default RouteWithSidebar;
